import { gql } from "@apollo/client"; // saveVisitaParenteral.js


const SAVE_VISITA_KETO_MEDICO = gql`
  mutation saveVisitaKetoMedico($input: AddVisitaKetoMedicoInput!) {
    saveVisitaKetoMedico(input: $input) {
      idVisita
      idVisitaKeto
    }
  }
`;

export default SAVE_VISITA_KETO_MEDICO;

export const adaptAddVisitaKetoMedicoInput = (data) => ({
  idVisitaKeto: data?.idVisitaKeto,
  idComboRIValorEstadio: data?.idComboRIValorEstadio,
  fG: data?.fG,
  justificacionModificacion: data?.justificacionModificacion,
  indicacionComentario: data?.indicacionComentario,
  complicaciones: data?.complicaciones,
  listaIndicacion: data?.listaIndicacion?.map((item) => ({
    idInsumo: item?.idInsumo,
    cantidadDiaria: item?.cantidadDiaria
  })),
  idVisita: data?.idVisita
});